<template>
  <div class="staff-card">
    <div class="section-inner">
      <StoryblokComponent
        v-if="blok.photo?.length === 1"
        class="photo"
        :blok="blok.photo[0]"
        :max-width="200"
      />
      <div class="infos size-xs">
        <span v-if="blok.name || blok.surname" class="name size-m bold">
          <template
            v-if="config.public['country'] === 'cl' && blok.name?.length"
          >
            {{ blok.name.toUpperCase() }} 
          </template>

          <template
            v-else
          >
            {{ blok.name }}
          </template>

          <template v-if="config.public['country'] !== 'es'">
            <template
              v-if="config.public['country'] === 'cl' && blok.name?.length"
            >
              {{ " "+blok.surname }}
            </template>

            <template
              v-else
            >
            {{ " "+blok.surname.toUpperCase() }}
            </template>
          </template>
        </span>
        <span v-if="blok.role">{{ blok.role }}</span>
        <span v-if="blok.details">{{ blok.details }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  blok: {
    type: Object,
    required: true,
  },
});

const config = useRuntimeConfig();
</script>

<style lang="scss" scoped>
.staff-card {
  .section-inner {
    @include pair-1;
    border-radius: $radius-m;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2rem;
    padding: 3.75rem col-span();
  }

  .photo {
    width: 9.375rem;
    height: 9.375rem;
    border-radius: $radius-l;
    overflow: hidden;
  }
  .photo :deep(img) {
    width: 100%;
    height: 100%;
  }
  .infos {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
  .name {
    color: var(--brand);
  }
}
</style>
